export const ERROR_CODES = {
  GOOGLE_LOGIN_ERROR: 1, // Googleログインエラー
  USER_ALREADY_EXISTS: 2, // ユーザー登録済
  USER_NOT_FOUND: 3, // ユーザー未登録
  AUTHENTICATION_ERROR: 4, // 認証エラー
  VALIDATION_ERROR: 5, // 入力値エラー
  PERMISSION_DENIED: 6, // 権限不足
  INVITE_ERROR: 7, // 招待エラー
  AUTH_CODE_SEND_ERROR: 8, // 認証コード送信エラー
  INVALID_OTP: 9, // 無効なOTP
  PAYMENT_ERROR: 10, // 支払いの失敗
  // 予約失敗
  RESERVATION_ERROR: 11, // 予約失敗
  // 支払い済み
  PAYMENT_DONE: 12, // 支払い済み
  PAYMENT_URL_GET_ERROR: 13, // 支払いURL取得エラー
  SEND_RECEIPT_ERROR: 14, // 領収書送信エラー
  SERVER_ERROR: 99, // サーバー内部エラー
} as const;

export type ERROR_CODES = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

/**
 * エラーコードに対応するメッセージを取得
 * @param code エラーコード
 * @returns エラーメッセージ
 */
export const getErrorMessage = (code: number): string => {
  switch (code) {
    case ERROR_CODES.GOOGLE_LOGIN_ERROR:
      return "Googleログイン中にエラーが発生しました。時間を置いて再度お試しください。";
    case ERROR_CODES.USER_ALREADY_EXISTS:
      return "このユーザーは既に登録されています。";
    case ERROR_CODES.USER_NOT_FOUND:
      return "ユーザーが見つかりません。新規登録を行ってください。";
    case ERROR_CODES.AUTHENTICATION_ERROR:
      return "認証に失敗しました。ログイン情報を確認してください。";
    case ERROR_CODES.VALIDATION_ERROR:
      return "入力値にエラーがあります。再度確認してください。";
    case ERROR_CODES.PERMISSION_DENIED:
      return "この操作を実行する権限がありません。";
    case ERROR_CODES.SERVER_ERROR:
      return "サーバー内部でエラーが発生しました。時間を置いて再度お試しください。";
    case ERROR_CODES.INVITE_ERROR:
      return "招待情報が見つかりません。有効期限が切れている可能性があります。";
    case ERROR_CODES.AUTH_CODE_SEND_ERROR:
      return "認証コードの送信に失敗しました。時間を置いて再度お試しください。";
    case ERROR_CODES.INVALID_OTP:
      return "認証コードが無効です。再度送信してお試しください。";
    case ERROR_CODES.PAYMENT_ERROR:
      return "支払い処理中にエラーが発生しました。時間を置いて再度お試しください。";
    case ERROR_CODES.RESERVATION_ERROR:
      return "予約処理に失敗しました。再度お試しください。";
    case ERROR_CODES.PAYMENT_URL_GET_ERROR:
      return "支払いURLの取得に失敗しました。時間を置いて再度お試しください。";
    case ERROR_CODES.PAYMENT_DONE:
      return "支払いは既に完了しています。";
    case ERROR_CODES.SEND_RECEIPT_ERROR:
      return "領収書の送信に失敗しました。時間を置いて再度お試しください。";
    default:
      return "不明なエラーが発生しました。時間を置いて再度お試しください。";
  }
};

export const getErrorMessageByUrl = (url: URL): string => {
  if (!url) {
    throw new Error("URLが指定されていません");
  }
  const code = url.searchParams.get("error");
  if (!code) {
    return "";
  }
  return getErrorMessage(Number(code));
};
